import { REFRESH_TOKEN } from "@/types";

export default function useGetAccessToken(): string | null {
  return (
    window.localStorage.getItem(REFRESH_TOKEN) ||
    window.sessionStorage.getItem(REFRESH_TOKEN)
  );
}
